import { useLayoutEffect, useState } from 'react'
import styles from './CoachLauncherDock.module.scss'
import { useCoachLauncherPlacement } from './CoachLauncherPlacement'

export default function CoachLauncherDock({
  fallback = false,
  game = false,
  compact = false,
  menu = false,
  className,
  onResetPosition,
}: {
  fallback?: boolean
  game?: boolean
  compact?: boolean
  menu?: boolean
  className?: string
  onResetPosition?: () => void
}) {
  const placement = useCoachLauncherPlacement()
  const register = placement?.register
  const [element, setElement] = useState<HTMLDivElement | null>(null)

  useLayoutEffect(() => {
    if (element && register)
      return register(
        element,
        fallback
          ? 'fallback'
          : game
            ? 'game'
            : menu
              ? 'menu'
              : compact
                ? 'compact-header'
                : 'header',
        onResetPosition,
      )
  }, [element, fallback, game, compact, menu, register, onResetPosition])

  if (!placement) return null
  return (
    <div
      ref={setElement}
      className={[
        fallback ? styles.fallback : game || compact ? styles.compact : styles.dock,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      hidden={fallback && (placement.hasHeader || placement.isPending)}
      data-testid={
        fallback ? 'coach-fallback-dock' : game ? 'coach-game-dock' : 'coach-header-dock'
      }
    />
  )
}
